import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

export const useOriginalPath = (isSettingsDashboard: boolean) => {
  const router = useRouter()
  const originalPathRef = useRef<string | null>(null)

  if (isSettingsDashboard && !originalPathRef.current) {
    const from = router.query.from
    const isValidFromPath = typeof from === 'string' && !from.includes('/settings')
    if (isValidFromPath) {
      originalPathRef.current = from
    } else {
      originalPathRef.current = '/'
    }
  }

  useEffect(() => {
    if (isSettingsDashboard) {
      const from = router.query.from
      const isValidFromPath = typeof from === 'string' && !from.includes('/settings')
      if (isValidFromPath) {
        originalPathRef.current = from
      }
    }
  }, [isSettingsDashboard, router.query.from])

  return originalPathRef.current || '/'
}
